import { makeStyles } from '@material-ui/core/styles';

export const priorityPopoverStyles = theme => ({
  selectedItems: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(0.25),
    marginTop: theme.spacing(1)
  },
  popoverContent: {
    minWidth: 160,
    '& .MuiMenuItem-root': {
      fontSize: theme.typography.body2.fontSize,
      padding: theme.spacing(1, 2),
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    }
  },
  priorityMenuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  popoverSectionTitle: {
    padding: theme.spacing(1, 2, 0.5)
  }
});

export const useAdvancedSearchStyles = makeStyles(theme => ({
  ...priorityPopoverStyles(theme),
  inputContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    alignItems: 'flex-start'
  },
  searchInput: {
    flex: 1
  },
  selectorsContainer: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1)
  },
  topWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    '& > button': {
      marginLeft: 'auto'
    }
  },
  optionRow: {
    width: '100%'
  },
  optionSelected: {
    margin: theme.spacing(-0.75, -2),
    padding: theme.spacing(0.75, 2),
    width: `calc(100% + ${theme.spacing(4)}px)`,
    backgroundColor: theme.palette.action.selected
  },
  collapsedContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    userSelect: 'none',
    border: 'none',
    background: 'none',
    padding: 0,
    fontSize: 'inherit',
    fontFamily: 'inherit',
    cursor: 'pointer',
    '& > span:first-child': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 20,
      height: 20,
      fontSize: theme.typography.h6.fontSize,
      fontWeight: 300,
      lineHeight: 1,
      color: theme.palette.text.secondary,
      transition: 'color 0.2s'
    },
    '& > span:last-child': {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.body2.fontSize,
      transition: 'color 0.2s'
    },
    '&:hover': {
      '& > span': {
        color: theme.palette.primary.main
      }
    }
  }
}));
